import { useState } from 'react'
import ConfirmDialog from '../ConfirmDialog'
import { Button } from '@/components/ui/button'
import { useTranslation } from 'react-i18next'
import { Undo2 } from 'lucide-react'

interface Props {
  className?: string
  label: string
  description: string
  buttonText?: string
  confirmation: string
  onDelete: () => void
  onRevert?: () => void
  loading?: boolean
  pendingUntil?: string | null
}

const DestructiveField = ({
  className,
  label,
  buttonText,
  description,
  confirmation,
  onDelete,
  onRevert,
  loading,
  pendingUntil,
}: Props) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)

  return (
    <div className={`mb-6 ${className ?? ''}`}>
      <div
        className={`grow bg-background py-3 px-3 rounded-md relative border border-destructive`}
      >
        <label className={'mr-24'}>{label}</label>
        <div className={'absolute right-6 top-4'}>
          {pendingUntil && onRevert ? (
            <Button
              variant='secondary'
              onClick={onRevert}
              className='flex items-center gap-2'
            >
              <Undo2 size={16} />
              {t('shared.undo')}
            </Button>
          ) : (
            <Button
              variant='destructive'
              onClick={() => setOpen(true)}
              loading={loading}
            >
              {buttonText ?? t('shared.delete')}
            </Button>
          )}
        </div>
        <p
          className={`mt-2 mr-32 text-sm ${
            pendingUntil ? 'text-destructive' : 'text-muted-foreground'
          } opacity-90`}
        >
          {description}
        </p>
      </div>

      <ConfirmDialog
        open={open}
        descriptionKey={confirmation}
        variant='destructive'
        onCancel={() => setOpen(false)}
        onContinue={() => {
          setOpen(false)
          onDelete()
        }}
      />
    </div>
  )
}

export default DestructiveField
